// COIN FLIP BOOTSTRAPPER - Polished for Sense
// Overwrites existing coin-flip.js

(function () {
  const DEBUG_PREFIX = "COINDEBUG:";
  const CHECK_INTERVAL_MS = 600;
  const MAX_ATTACH_ATTEMPTS = 25;
  let flipTriggered = false;
  const STOREFRONT_TOKEN = "ca6c3773fd75daa86ab48af6809e8c9b";
  const STOREFRONT_API = "/api/2024-01/graphql.json";


  

function dlog(...args) {
  console.log(DEBUG_PREFIX, ...args);
}


  // Find modal and related elements
  function findModalElements() {
    const modal = document.getElementById("coin-flip-modal");
    const overlay = document.getElementById("coin-backdrop"); // matches your HTML
    const coin = document.getElementById("coin");
    const flipBtn = document.getElementById("coin-flip-btn");
    const closeBtn = document.getElementById("coin-close");
    const resultEl = document.getElementById("coin-result");
    return { modal, overlay, coin, flipBtn, closeBtn, resultEl };
  }

  // Get checkout buttons
  function findCheckoutButtons() {
    const selectors = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'button[type="submit"][form="cart"]',
      ".cart__checkout-button",
      "[data-checkout-button]",
      ".cart__submit",
      ".cart-footer__checkout-button",
      ".totals__checkout",
      '[href*="/checkout"]',
      "cart-checkout-button button",
      '[data-testid*="Checkout"]',
      '[data-test*="checkout"]',
    ];
    const set = new Set();
    selectors.forEach((sel) => {
      try {
        document.querySelectorAll(sel).forEach((el) => set.add(el));
      } catch {}
    });
    return Array.from(set);
  }

  // Show modal
  function showModal() {
    const waitForModal = () => {
      const { modal, overlay, coin, flipBtn, closeBtn, resultEl } =
        findModalElements();
      if (!modal || !overlay || !coin || !flipBtn || !closeBtn || !resultEl) {
        setTimeout(waitForModal, 100);
        return;
      }

      overlay.style.display = "block";
      modal.style.display = "flex"; // because modal uses display:flex to center
      modal.classList.remove("hidden");

      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      // Coin flip button
      flipBtn.onclick = () => flipCoin(coin, resultEl);

      // Close modal
      closeBtn.onclick = hideModal;
      overlay.onclick = hideModal;

      dlog("Modal shown successfully.");
    };
    waitForModal();
  }

  // Hide modal
  function hideModal() {
    flipTriggered = false;
    const { modal, overlay, coin, resultEl } = findModalElements();
    if (!modal || !overlay || !coin || !resultEl) return;
    modal.classList.add("hidden");
    modal.setAttribute("aria-hidden", "true");
    overlay.style.display = "none";
    document.body.style.overflow = "";
    coin.classList.remove("flip");
    resultEl.textContent = "";

    flipTriggered = false;
  }

  // Flip coin and show reward
  function flipCoin(coin, resultEl) {
    coin.classList.remove("flip");
    resultEl.textContent = "";

    setTimeout(() => {
      coin.classList.add("flip");

      setTimeout(() => {
        const rewards = [
          { type: "auto_discount", value: "10_percent" },
          { type: "auto_gift", handle: "50ml-perfume-gift" }
        ];

        let reward = sessionStorage.getItem("coinReward");
        if (reward) {
          reward = JSON.parse(reward);
        } else {
          reward = rewards[Math.floor(Math.random() * rewards.length)];
          sessionStorage.setItem("coinReward", JSON.stringify(reward));
        }

        resultEl.textContent =
          reward.type === "auto_discount"
            ? `You won: 10% discount`
            : `You won: Free 50ml perfume`;

        setTimeout( async () => {
          hideModal();

          if (reward.type === "auto_discount") {
            const res = await fetch("https://coin-discount.troj9226.workers.dev", {
              method: "POST"
            });

            const data = await res.json();

          if (!data.code) {
            alert("Failed to apply discount");
          return;
          }

          window.location.href = `/checkout?discount=${data.code}`;
          }

          if (reward.type === "auto_gift") {
            // CLEAR discount attribute
            fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                attributes: { coin_reward: "" }
              })
            });

            showGiftChoiceModal();

            // THEN add the gift
            //fetch("/cart/add.js", {
              //method: "POST",
              //headers: { "Content-Type": "application/json" },
              //body: JSON.stringify({
                //items: [{ id: 47200588595435, quantity: 1 }]
              //})
            //}).then(() => {
              //sessionStorage.setItem("coinGoCheckout", "true");
              //window.location.href = "/cart";
              
            //});
          }

          return;

        }, 3000);
      }, 1000);
    }, 100);

  }

async function showGiftChoiceModal(options = {}) {
  const isEdit = options.edit === true;

  /* --------------------
     ELEMENTS
  -------------------- */
  const modal = document.getElementById("coin-gift-choice-modal");
  if (!modal) {
    console.warn("COINDEBUG: Gift modal not found");
    return;
  }

  const backdrop = modal.querySelector(".coin-modal__backdrop");
  const closeBtn = modal.querySelector(".coin-modal__close");
  const confirmBtn = modal.querySelector("#confirm-gift-choice");
  const searchInput = modal.querySelector("#gift-search-input");
  const resultsBox = modal.querySelector("#gift-search-results");
  const hiddenInput = modal.querySelector("#gift-selected-perfume");

  if (!confirmBtn || !searchInput || !resultsBox || !hiddenInput) {
    console.warn("COINDEBUG: Gift choice modal missing elements");
    return;
  }

  /* --------------------
     FETCH PERFUMES
  -------------------- */
  console.log("COINDEBUG: Loading perfumes…");
  const perfumes = await getPerfumesCached();
  console.log("COINDEBUG: Perfumes loaded:", perfumes.length);

  /* --------------------
     RENDER RESULTS
  -------------------- */
  resultsBox.innerHTML = "";

  perfumes.forEach((p, index) => {
    const li = document.createElement("li");
    li.className = "gift-result-item";
    li.dataset.title = p.title.toLowerCase();
    li.dataset.index = index;
    li.dataset.name = p.title;

    li.innerHTML = `
      <img src="${p.featuredImage?.url || ""}" alt="${p.title}" width="60" height="60">
      <span class="gift-title">${p.title}</span>
    `;

    resultsBox.appendChild(li);
  });

  const resultItems = resultsBox.querySelectorAll(".gift-result-item");
  console.log("COINDEBUG: resultItems rendered:", resultItems.length);

  /* --------------------
     SHOW MODAL
  -------------------- */
  modal.classList.remove("hidden");
  modal.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";

  /* --------------------
     BLOCK CLOSING
  -------------------- */
  if (closeBtn) {
    closeBtn.onclick = () => {
      if (sessionStorage.getItem("coinGiftEditMode") === "true") {
        alert("Please confirm your perfume choice to continue.");
        return;
      }
      hideModal();
    };
  }

  if (backdrop) {
    backdrop.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
  }

  /* --------------------
     RESET STATE
  -------------------- */
  searchInput.value = hiddenInput.value || "";
  resultsBox.classList.add("hidden");

  let selectedPerfume = hiddenInput.value || "";

  /* --------------------
     SEARCH FILTER
  -------------------- */
  searchInput.oninput = () => {
    const q = searchInput.value.toLowerCase().trim();
    let hasResults = false;

    resultItems.forEach((item) => {
      const match = item.dataset.title.includes(q);
      item.style.display = match ? "flex" : "none";
      if (match) hasResults = true;
    });

    resultsBox.classList.toggle("hidden", !hasResults);
  };

  /* --------------------
     SELECT PERFUME
  -------------------- */
  resultItems.forEach((item) => {
    item.onclick = () => {
      resultItems.forEach(i => i.classList.remove("selected"));
      item.classList.add("selected");

      const perfumeIndex = Number(item.dataset.index);
      selectedPerfume = perfumes[perfumeIndex];
      searchInput.value = selectedPerfume.title;
      hiddenInput.value = selectedPerfume.title;
      resultsBox.classList.add("hidden");

      console.log("COINDEBUG: Selected perfume:", selectedPerfume);
    };
  });

  /* --------------------
     CONFIRM SELECTION
  -------------------- */
  confirmBtn.onclick = async () => {
    if (!selectedPerfume) {
      alert("Please choose your perfume");
      return;
    }

    confirmBtn.disabled = true;

    const editMode = sessionStorage.getItem("coinGiftEditMode") === "true";
    const lineKey = sessionStorage.getItem("coinGiftEditLineKey");

    try {
      if (editMode && lineKey) {
        // UPDATE EXISTING GIFT
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lineKey,
            properties: {
               "_isGift": "true",
                "Chosen Perfume": selectedPerfume.title,
                "_chosenPerfumeImage": selectedPerfume.featuredImage.url,
                "_chosenPerfumeHandle": selectedPerfume.handle
            },
          }),
        });

        console.log("COINDEBUG: Gift choice updated");
      } else {
        // ADD GIFT FIRST TIME
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: 47200588595435, // gift variant ID
                quantity: 1,
                properties: {
                  "_isGift": "true",
                "Chosen Perfume": selectedPerfume.title,
                "_chosenPerfumeImage": selectedPerfume.featuredImage.url,
                "_chosenPerfumeHandle": selectedPerfume.handle
                },
              },
            ],
          }),
        });

        sessionStorage.setItem("coinGiftResolved", "true");
      }

      sessionStorage.removeItem("coinGiftEditMode");
      sessionStorage.removeItem("coinGiftEditLineKey");

      window.location.href = "/cart";
    } catch (err) {
      console.error("COINDEBUG: Gift update failed", err);
      confirmBtn.disabled = false;
      alert("Something went wrong. Please try again.");
    }
  };
}






  function showAlreadyWonModal(reward) {
  const modal = document.getElementById("coin-already-won-modal");
  const backdrop = document.getElementById("coin-already-won-backdrop");
  const closeBtn = document.getElementById("coin-already-won-close");
  const content = document.getElementById("coin-already-won-content");
  const checkoutBtn = document.getElementById("coin-already-won-checkout");

  if (!modal || !content) {
    console.warn("COINDEBUG: AlreadyWon modal missing");
    return;
  }

  let rewardText = "Your reward";

  if (reward.type === "auto_discount") {
    rewardText = "10% off your order";
  } else if (reward.type === "auto_gift") {
    rewardText = "Free 50ml perfume of your choice";
  }

  content.innerHTML = `
    <p>You’ve already flipped the coin for this order.</p>
    <p style="margin-top:8px;font-weight:600;">
      Reward: <strong>${rewardText}</strong>
    </p>
    <p style="margin-top:8px;font-size:13px;opacity:.8;">
      Each order includes one reward.  
      Complete this purchase to unlock a new flip.
    </p>
  `;

  modal.classList.remove("hidden");
  modal.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";

  checkoutBtn.onclick = () => {
    window.location.href = "/checkout";
  };

  closeBtn.onclick = backdrop.onclick = () => {
    modal.classList.add("hidden");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  flipTriggered = false;

  console.log("COINDEBUG: AlreadyWon modal shown");
}


async function shouldInterceptCheckout() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    console.log("COINDEBUG: Cart item_count =", cart.item_count);

    return cart.item_count >= 2;
  } catch (err) {
    console.error("COINDEBUG: Cart check failed", err);
    return false; // Fail-safe: allow checkout
  }
}

function resumeCheckout(source) {
  console.log("COINDEBUG: Resuming normal checkout");

  if (source === "form-submit") {
    const form = document.querySelector(
      'form[action$="/cart"], form[form="cart"], form.cart__contents'
    );
    if (form) {
      form.submit();
      return;
    }
  }

  // Fallback
  window.location.href = "/checkout";
}



function handleCheckoutAttempt(e, source) {
  console.log("🔥 COINDEBUG: Intercepting checkout from:", source);

  if (flipTriggered) return;

  flipTriggered = true;

  const rewardRaw = sessionStorage.getItem("coinReward");
  const giftResolved = sessionStorage.getItem("coinGiftResolved") === "true";

  if (rewardRaw) {
    const reward = JSON.parse(rewardRaw);

    if (reward.type === "auto_gift" && !giftResolved) {
      showGiftChoiceModal();
      return;
    }

    showAlreadyWonModal(reward);
    return;
  }

  showModal();
}




  // Attach to buttons
  function attachToButtons(btns) {
    let attached = 0;
    btns.forEach((btn) => {
      if (!btn || btn.dataset.coinBound === "true") return;
      try {
        btn.addEventListener(
          "click",
          async (e) => {
            console.log("🔥 COINDEBUG: Button click detected");

            e.preventDefault();

            const intercept = await shouldInterceptCheckout();

            if (!intercept) {
              resumeCheckout("button-click");
              return;
            }

            handleCheckoutAttempt(e, "button-click");
          },
          { passive: false }
        );



        btn.dataset.coinBound = "true";
        attached++;
      } catch (err) {
        dlog("Attach failed:", btn, "error:", err);
      }
    });
    return attached;
  }

  // Attach to cart forms
  function attachToForms() {
  const forms = document.querySelectorAll(
    'form[action$="/cart"], form[form="cart"], form.cart__contents'
  );

  let attached = 0;

  forms.forEach((form) => {
    if (!form || form.dataset.coinFormBound === "true") return;

    try {
      form.addEventListener(
        "submit",
        async function (e) {
          console.log("🔥 COINDEBUG: Submit detected");

          e.preventDefault();
          e.stopImmediatePropagation();

          const intercept = await shouldInterceptCheckout();

          if (!intercept) {
            resumeCheckout("form-submit");
            return;
          }

          handleCheckoutAttempt(e, "form-submit");
        },
        true
      );



      form.dataset.coinFormBound = "true";
      attached++;
      console.log("🔥 COINDEBUG: Submit listener attached to form", form);
    } catch (err) {
      console.log("🔥 COINDEBUG: Attach failed on form", err);
    }
  });

  return attached;
}

async function fetchAllPerfumes() {
  let products = [];
  let cursor = null;
  let hasNextPage = true;

  console.log("COINDEBUG: Fetching perfumes from Storefront API");

  while (hasNextPage) {
    const res = await fetch(STOREFRONT_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({
        query: `
          query GetPerfumes($cursor: String) {
  collection(handle: "all-perfumes") {
    products(first: 250, after: $cursor) {
      edges {
        cursor
        node {
          id
          title
          handle
          featuredImage {
            url(
              transform: {
                maxWidth: 300
                maxHeight: 300
                preferredContentType: JPG
              }
            )
            altText
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}

        `,
        variables: { cursor },
      }),
    });

    const json = await res.json();

    if (!json.data || !json.data.collection) {
      console.error("COINDEBUG: Invalid Storefront response", json);
      break;
    }

    const edges = json.data.collection.products.edges;

    edges.forEach(edge => products.push(edge.node));

    hasNextPage = json.data.collection.products.pageInfo.hasNextPage;
    cursor = cursor = json.data.collection.products.pageInfo.endCursor;
  }

  console.log("COINDEBUG: Loaded perfumes:", products.length);
  return products;
}

async function getPerfumesCached() {
  const cached = sessionStorage.getItem("coinPerfumes");
  if (cached) {
    return JSON.parse(cached);
  }

  const perfumes = await fetchAllPerfumes();
  sessionStorage.setItem("coinPerfumes", JSON.stringify(perfumes));
  return perfumes;
}



  // Boot attach
  function bootAttach() {
    dlog("Boot attach starting.");
    const btns = findCheckoutButtons();
    const attachedButtons = attachToButtons(btns);
    const attachedForms = attachToForms();
    dlog("attachedButtons:", attachedButtons, "attachedForms:", attachedForms);
    return { attachedButtons, attachedForms };
  }

  // Start attach loop
  function start() {
    let attempts = 0;
    const intervalId = setInterval(() => {
      attempts++;
      const res = bootAttach();
      if (res.attachedButtons > 0 || res.attachedForms > 0) {
        dlog("Listeners attached. Stopping retry.");
        clearInterval(intervalId);
        return;
      }
      if (attempts >= MAX_ATTACH_ATTEMPTS) {
        dlog("Max attempts reached. Using MutationObserver.");
        clearInterval(intervalId);
        setupMutationObserver();
      }
    }, CHECK_INTERVAL_MS);
  }

  // Observe late DOM changes
  function setupMutationObserver() {
    dlog("Setting up MutationObserver.");
    const obs = new MutationObserver(() => {
      const res = bootAttach();
      if (res.attachedButtons > 0 || res.attachedForms > 0) {
        dlog("Listeners attached via MutationObserver. Disconnecting.");
        try {
          obs.disconnect();
        } catch {}
      }
    });
    obs.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("click", (e) => {
  const btn = e.target.closest(".gift-edit-btn");
  if (!btn) return;

  const lineKey = btn.dataset.lineKey;
  if (!lineKey) return;

  console.log("COINDEBUG: Editing gift for line", lineKey);

  // Store edit context
  sessionStorage.setItem("coinGiftEditLineKey", lineKey);
  sessionStorage.setItem("coinGiftEditMode", "true");

  showGiftChoiceModal({ edit: true });
});


  // Manual debug
  window.COIN_FLIP_DEBUG = {
    triggerManual: function () {
      dlog("Manual trigger invoked.");
      showModal();
    },
    status: function () {
      const { modal, overlay } = findModalElements();
      const btns = findCheckoutButtons();
      dlog(
        "Status -> modal:",
        modal,
        "overlay:",
        overlay,
        "buttons:",
        btns.length,
        "flipTriggered:",
        flipTriggered,
      );
      return { modal, overlay, buttonCount: btns.length, flipTriggered };
    },
  };

  // Kickoff
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  dlog("Coin flip JS loaded. Use COIN_FLIP_DEBUG.status() or .triggerManual()");
})();
